import {Component, ViewEncapsulation} from '@angular/core';

import {Router} from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import {AuthService} from 'app/services/auth.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-error-404',
  templateUrl: './error-404.component.html',
  styleUrls: ['./error-404.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Error404Component {
  /**
   * Constructor
   */
  constructor(private router: Router,
              private auth: AuthService,
              private fuseConfigService: FuseConfigService,
              private location: Location
              ) {
                this.auth.isLoggedIn().then(response => {
                  this.fuseConfigService.config = {
                    layout: {
                      navbar: {
                        hidden: !response
                      },
                      toolbar: {
                        hidden: !response
                      },
                      sidepanel: {
                        hidden: !response
                      }
                    }
                  };
                });
               }

  back(): void {
    // this._router.navigate([AppRoutePaths.DEFAULT]);
    // this.auth.checkFirstAllowedMenuItem();
    this.location.back();
  }
  logout(): void {
    this.auth.isLoggedIn().then(response => {
      if (response) {
        this.auth.logout();
      } else {
        this.router.navigate(['/']);
      }
    });
  }
}
